import Styled from 'styled-components';
import { Card } from '@amount/frontend-components';

export const StyledCrossSellCard = Styled(Card)`
  height: 450px;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
`;
